<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container mt-5">
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Trainee/traineeDashboard'
                    },
                   {
                      title: 'Videos',
                      active: true
                    }
                  ]"
              ></vs-breadcrumb>
              <div class="frm-title">
                <div class="heading">
                  <h3>videos</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3" v-if="videosArray !=''">
            <div class="col-lg-4 mb-1" v-for="(video,index) in videosArray" v-bind:key="index">
              <!-- video player starts -->
              <div class="vd-crd">
                <video controls>
                  <source :src="BASEPATHDYNAMIC+'/'+video.uploadfile" />
                  <source :src="BASEPATHDYNAMIC+'/'+video.uploadfile" />Your browser does not support HTML5 video.
                </video>
                <h6 class="vid-title">{{video.title}}</h6>
              </div>
              <!-- video player ends -->
            </div>
          </div>
          <div class="row mb-3" v-else>
            <div class="col-lg-12 mb-1">
              <!-- video player starts -->
              <div class="vd-crd">
                <h6 class="vid-title">No Video Found</h6>
              </div>
              <!-- video player ends -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";
export default {
  data: () => ({
    isSidebar: false,
    active: false,
    currentx: 30,
    trainingId: "",
    BASEPATHDYNAMIC: "",
    videosArray: [],
    showImgFilter: false,
    showPresFilter: true
    // videojs options
  }),
  mounted() {},
  created() {
    this.trainingId = this.$route.query.training;
    this.BASEPATHDYNAMIC = localStorage.getItem("BASE_PATH");
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/trainer/videos/get/" +
          this.trainingId +
          ""
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.videosArray = response.data;
      });
  },
  computed: {},

  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },

    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Files have been Uploaded, consectetur"
      });
    },
    showImg() {
      this.showImgFilter = true;
      this.showPresFilter = false;
    }
  }
};
</script>

<style >
.thumb-image {
  padding: 20px;
  float: left;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  /* border: 4px solid #ddd; */
  /* border: 1px solid #ebebeb; */
  /* margin: 5px; */
}

.vs-sidebar.vs-sidebar-primary.vs-sidebar-parent {
  height: 100% !important;
  padding-left: 10px;
  border-right: 1px solid #d4d4d487;
}

.vs-sidebar-parent {
  border-right: 1px solid #d4d4d487 !important;
}

.vs-pagination--ul {
  margin-top: 15px;
}
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
video {
  background-color: #000000;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  height: 150px;
}
.vid-title {
  margin-top: -4px;
  background-color: #06a6e0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 5px;
  color: #fff;
}
.vd-crd {
  border-radius: 5px;
  -webkit-box-shadow: -4px 4px 5px 1px rgba(171, 171, 171, 0.77);
  -moz-box-shadow: -4px 4px 5px 1px rgba(171, 171, 171, 0.77);
  box-shadow: -4px 4px 5px 1px rgba(171, 171, 171, 0.77);
}
</style>  




